import { Grid, Link, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ButtonAccordionValue } from '../../../model/accordion-value';

function ReviewFnolSummary(props: any) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const displayRowValue = (object: ButtonAccordionValue) => {
    if (object.mask) {
      return (
        <span data-dd-privacy="mask" data-dd-action-name={object.rowName}>
          {object.rowValue}
        </span>
      );
    } else {
      return object.rowValue;
    }
  };

  return (
    <div>
      {props?.info?.map(function (object: ButtonAccordionValue, i: number) {
        return (
          <Grid container key={object.rowName ? object.rowName : object.rowValue}>
            <Grid
              sx={(i + 1) % 2 === 0 ? theme.custom.styles.evenRow : theme.custom.styles.oddRow}
              key={object.rowName}
              item
              xs={4}
            >
              <Typography
                variant="body1"
                sx={{
                  marginLeft: '10px',
                  marginTop: '15px',
                  marginBottom: '15px',
                }}
                key={object.rowName + '-p'}
                id={'2'}
              >
                <b>{object.rowName}</b>
              </Typography>
            </Grid>
            <Grid
              sx={(i + 1) % 2 === 0 ? theme.custom.styles.evenRow : theme.custom.styles.oddRow}
              key={object.rowValue}
              item
              xs={6}
            >
              <Typography
                variant="body1"
                title={object.rowName + '-' + object.rowValue}
                key={object.rowValue + '-p'}
                sx={{
                  width: '100%',
                  textAlign: object.rowName ? 'end' : 'start',
                  marginRight: '0rem',
                  wordWrap: 'break-word', // Ensures long words break to the next line
                  overflow: 'visible', // Ensures content is visible
                  whiteSpace: 'normal', // Allows text to wrap naturally
                }}
              >
                {displayRowValue(object)}
              </Typography>
            </Grid>

            <Grid
              sx={(i + 1) % 2 === 0 ? theme.custom.styles.evenRow : theme.custom.styles.oddRow}
              key={object.rowName + '-button'}
              item
              xs={2}
            >
              {object.showEdit && (
                <Link
                  onClick={() => props.handleEdit(object)}
                  underline={'hover'}
                  sx={theme.custom.styles.editOnReviewStyle}
                >
                  Edit
                </Link>
              )}
            </Grid>

            <Grid
              sx={{
                minWidth: '100%',
                ...((i + 1) % 2 !== 0
                  ? theme.custom.styles.hrWrapperOdd
                  : i + 1 !== props?.info?.length
                    ? theme.custom.styles.hrWrapperEven
                    : theme.custom.styles.hrWrapperEven),
              }}
              item
              xs={12}
            >
              {(!isMobile || (isMobile && theme.custom.styles.showReviewItemDividerLineOnMobile)) && (
                <hr
                  style={{
                    width: '100%',
                    height: theme.custom.styles.defaultBorderWidth,
                    border: 0,
                    borderTop: `1px solid ${theme.custom.colors.defaultBorderColor}`,
                  }}
                />
              )}
            </Grid>
          </Grid>
        );
      })}
    </div>
  );
}

export default ReviewFnolSummary;
